import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { useI18n } from 'hooks/useI18n';
import { useEffect, useRef, useState } from 'react';
import ServiceEventTracking from 'services/service.event-tracking';
import { StyledBottomBar, StyledContainer } from './BottomBar.styled';

const BottomBar: React.FC = () => {
  const { t } = useI18n('companies-new');

  const bottomBarRef = useRef<HTMLDivElement>(null);

  const [setAttached, setAttachedState] = useState(false);
  const [isScroll, setScrollState] = useState(false);

  const handleScroll = (): void => {
    const heroHeight =
      document.querySelector('.companiesHero')?.getBoundingClientRect()
        .height || 150;

    let bottomBarPosition = heroHeight;

    setScrollState(true);

    if (bottomBarRef?.current) {
      bottomBarPosition = bottomBarRef.current.getBoundingClientRect().bottom;
    }

    setAttachedState(window.innerHeight > bottomBarPosition);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <StyledBottomBar
      ref={bottomBarRef}
      className={`${setAttached ? 'is-detached' : ''} ${
        isScroll ? 'is-scroll' : ''
      }`}
    >
      <StyledContainer>
        <ButtonLink
          href="#companiesForm"
          variant="primaryInverse"
          sizes="md"
          onClick={() =>
            ServiceEventTracking.trackLandingCtaClicked(
              'hablemos-footer-empresas'
            )
          }
        >
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{t('companies-new.bottomBar.cta')}</span>
        </ButtonLink>
      </StyledContainer>
    </StyledBottomBar>
  );
};

export default BottomBar;
